import React, { useState, useEffect } from 'react'
import { Col, Row, Space, Card, Select, Button, Tag, Calendar, Badge, Divider } from "antd";
import Search from "antd/es/input/Search";
import { MailOutlined, CheckSquareOutlined, PrinterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import AddLetter from './modal/AddLetter';
import CheckCONTNO from './modal/CheckCONTNO';
import ReportLetter from './modal/ReportLetter';
import { getStatusColor, computeTabStatus } from './hook/function';

function CalendarView({ masterData, activeCalendarTab, onTabChange, onSelectDate, onReload, calendarValue, calendarMode, onCalendarChange }) {
  const [calendarPoint, setCalendarPoint] = useState([]);
  const [isModalAddLetter, setIsModalAddLetter] = useState(false);
  const [dataSearch, setDataSearch] = useState();
  const [isModalSearch, setIsModalSearch] = useState(false);
  const [isModalReport, setIsModalReport] = useState(false);

  useEffect(() => {
    if (masterData.length === 0) return;
    const base = activeCalendarTab === "post"
      ? masterData.filter(i => i?.status3 === "รอคอนเฟิร์ม")
      : masterData.filter(i => i?.status3 === "คอนเฟิร์มแล้ว");
    setCalendarPoint(base);
  }, [activeCalendarTab, masterData]);

  const getListData = (value) => {
    if (!calendarPoint || calendarPoint.length === 0) return [];
    return calendarPoint.filter((item) => dayjs(item.dateReply).isSame(value, 'day'));
  };

  const handleSelectDate = (value) => {
    if (calendarMode === 'year') {
      onCalendarChange(value, null);
      return;
    }
    onCalendarChange(value, null);
    const dayList = getListData(value);
    onSelectDate(value, dayList);
  };

  const tabBaseData = activeCalendarTab === "post"
    ? masterData.filter(i => i?.status3 === "รอคอนเฟิร์ม")
    : masterData.filter(i => i?.status3 === "คอนเฟิร์มแล้ว");

  const handleFilterStatus = (value) => {
    if (value === "ทั้งหมด") {
      setCalendarPoint(tabBaseData);
      return;
    }
    const filtered = tabBaseData.filter((item) => {
      if (["บอกกล่าว", "สิทธิซื้อรถคืน", "แจ้งราคาขายรถ", "บอกเลิก", "แจ้งผลประมูล"].includes(value)) return item?.status1 === value;
      if (["อยู่ระหว่างการนำจ่าย", "นำจ่ายไม่สำเร็จ", "นำจ่ายสำเร็จ"].includes(value)) return item?.status2 === value;
      if (["ส่งถึงแล้วไม่ตอบกลับ", "ไม่มีการเคลื่อนไหว", "ตอบกลับ", "ตีกลับ", "ตอบกลับ(เว็บ)", "ตีกลับ(เว็บ)"].includes(value)) return item?.status4 === value;
      return false;
    });
    setCalendarPoint(filtered);
  };

  const handleChangeDate = (e) => {
    onCalendarChange(e, null);
    onReload(e);
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    if (!listData || listData.length === 0) return null;
    const countType1 = listData.filter(e => e.typeReply === 1).length;
    const countType2 = listData.filter(e => e.typeReply === 2).length;
    const countType3 = listData.filter(e => e.typeReply === 3).length;
    const countType4 = listData.filter(e => e.typeReply === 4).length;
    const countType5 = listData.filter(e => e.typeReply === 5).length;
    const countType6 = listData.filter(e => e.typeReply === 6).length;
    const countType7 = listData.filter(e => e.typeReply === 7).length;
    const countType8 = listData.filter(e => e.typeReply === 88).length;
    return (
      <div style={{ textAlign: 'center', minHeight: '100%', height: '100%' }}>
        <div>
          <b><Badge color="green" text={`${listData.length} รายการ`} style={{ fontSize: '12px' }} /></b>
          {countType1 > 0 && <div style={{ marginBottom: 2 }}><Tag color="cyan">บอกกล่าว ({countType1})</Tag></div>}
          {countType2 > 0 && <div style={{ marginBottom: 2 }}><Tag color="purple">สิทธิซื้อรถคืน ({countType2})</Tag></div>}
          {countType3 > 0 && <div style={{ marginBottom: 2 }}><Tag color="orange">แจ้งราคาขายรถ ({countType3})</Tag></div>}
          {countType4 > 0 && <div style={{ marginBottom: 2 }}><Tag color="magenta">บอกเลิก ({countType4})</Tag></div>}
          {countType5 > 0 && <div style={{ marginBottom: 2 }}><Tag color="magenta">บอกเลิก(มือ) ({countType5})</Tag></div>}
          {countType6 > 0 && <div style={{ marginBottom: 2 }}><Tag color="purple">สิทธิซื้อรถคืน(เก่า) ({countType6})</Tag></div>}
          {countType7 > 0 && <div style={{ marginBottom: 2 }}><Tag color="magenta">พิพากษา ({countType7})</Tag></div>}
          {countType8 > 0 && <div style={{ marginBottom: 2 }}><Tag color="purple">แจ้งผลประมูล ({countType8})</Tag></div>}
        </div>
      </div>
    );
  };

  return (
    <>
      <Row justify="end" style={{ padding: '0 12px' }}>
        <Col>
          <Search
            placeholder="ค้นหาสัญญา"
            enterButton
            onSearch={(v) => { setDataSearch(v); setIsModalSearch(true); }}
            style={{ width: "auto", borderRadius: "8px" }}
            size="large"
          />
        </Col>
      </Row>
      <Row justify="end" style={{ marginBottom: 8, padding: '0 12px', marginTop: 8 }}>
        <Col>
          <Button type='primary' icon={<MailOutlined />} style={{ backgroundColor: 'orange', marginRight: 8 }} onClick={() => setIsModalAddLetter(true)}>
            เพิ่มจดหมาย
          </Button>
          <Button icon={<PrinterOutlined />} onClick={() => setIsModalReport(true)}>
            รายงาน
          </Button>
        </Col>
      </Row>
      <div style={{ display: 'flex', marginBottom: 0 }}>
        <div
          onClick={() => onTabChange("post")}
          style={{ flex: 1, textAlign: 'center', padding: '16px 0', fontSize: 18, fontWeight: 'bold', cursor: 'pointer', background: activeCalendarTab === "post" ? '#e3000f' : '#f0f0f0', color: activeCalendarTab === "post" ? '#fff' : '#aaa', borderRadius: '10px 0 0 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, transition: 'all 0.2s', boxShadow: activeCalendarTab === "post" ? 'inset 0 -3px 0 rgba(0,0,0,0.15)' : 'none', userSelect: 'none' }}
        >
          <MailOutlined style={{ fontSize: 22 }} />
          ปฎิทินไปรษณีย์
          <span style={{ background: activeCalendarTab === "post" ? 'rgba(255,255,255,0.25)' : '#ddd', color: activeCalendarTab === "post" ? '#fff' : '#999', borderRadius: 20, padding: '2px 10px', fontSize: 13 }}>
            {masterData.filter(i => i?.status3 === "รอคอนเฟิร์ม").length}
          </span>
        </div>
        <div
          onClick={() => onTabChange("collect")}
          style={{ flex: 1, textAlign: 'center', padding: '16px 0', fontSize: 18, fontWeight: 'bold', cursor: 'pointer', background: activeCalendarTab === "collect" ? '#52c41a' : '#f0f0f0', color: activeCalendarTab === "collect" ? '#fff' : '#aaa', borderRadius: '0 10px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, transition: 'all 0.2s', boxShadow: activeCalendarTab === "collect" ? 'inset 0 -3px 0 rgba(0,0,0,0.15)' : 'none', userSelect: 'none' }}
        >
          <CheckSquareOutlined style={{ fontSize: 22 }} />
          ปฎิทินจัดเก็บ
          <span style={{ background: activeCalendarTab === "collect" ? 'rgba(255,255,255,0.25)' : '#ddd', color: activeCalendarTab === "collect" ? '#fff' : '#999', borderRadius: 20, padding: '2px 10px', fontSize: 13 }}>
            {masterData.filter(i => i?.status3 === "คอนเฟิร์มแล้ว").length}
          </span>
        </div>
      </div>
      <Calendar
        value={calendarValue}
        mode={calendarMode}
        onSelect={handleSelectDate}
        onPanelChange={(v, m) => { onCalendarChange(v, m); }}
        cellRender={(current, info) => {
          if (info.type === 'date') return dateCellRender(current);
          return info.originNode;
        }}
        headerRender={({ value }) => {
          const cur = value.clone();
          const years = Array.from({ length: 11 }, (_, i) => dayjs().year() - 5 + i);
          const months = Array.from({ length: 12 }, (_, i) => ({ value: i, label: dayjs().month(i).format("MMMM") }));
          return (
            <div style={{ minHeight: '120px', height: '100%' }}>
              <Card>
                <Row>
                  <Col span={24} style={{ textAlign: 'start' }}>
                    <Select value={cur.month()} options={months} onChange={(m) => handleChangeDate(cur.month(m))} style={{ width: '200px' }} size='large' />
                    <Select value={cur.year()} options={years.map(y => ({ value: y, label: y }))} onChange={(y) => handleChangeDate(cur.year(y))} style={{ width: '200px' }} size='large' />
                  </Col>
                </Row>
                <Col span={24} style={{ textAlign: 'start', marginTop: 5 }}>
                  <Space wrap size={[12, 12]}>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {[
                        { status: "ทั้งหมด", nameStatus: "ทั้งหมด", totalCount: tabBaseData.length },
                        ...computeTabStatus(tabBaseData)
                      ].map((item, index) => (
                        <Tag
                          key={index}
                          color={getStatusColor(item.status)}
                          style={{ cursor: 'pointer', padding: '5px 12px', width: "auto" }}
                          onClick={() => handleFilterStatus(item.status)}
                        >
                          <span style={{ fontWeight: 'bold' }}>
                            {item.nameStatus}
                            <span style={{ marginLeft: '8px', opacity: 0.8 }}>({item.totalCount})</span>
                          </span>
                        </Tag>
                      ))}
                    </div>
                  </Space>
                </Col>
              </Card>
              <Divider />
            </div>
          );
        }}
      />
      {isModalAddLetter && <AddLetter open={isModalAddLetter} close={setIsModalAddLetter} loadData={onReload} />}
      {isModalSearch && <CheckCONTNO open={isModalSearch} close={setIsModalSearch} data={dataSearch} />}
      {isModalReport && <ReportLetter open={isModalReport} close={setIsModalReport} />}
    </>
  );
}

export default CalendarView;
